import {ActionType} from '@ant-design/pro-table';
import {
  FrontendSupportService,
  SupportEntityListFrontendList,
} from '@common/api';
import {Button} from 'antd';
import {CommonManager} from 'components/Common/Manager';
import {CommonTable} from 'components/Common/Table';
import {useApi} from 'hooks/useApi';
import {genRequest} from 'libs/genRequest';
import {BackendSupportReport} from './Report';

const SetIsReadButton = ({
  data,
  action,
}: {
  data: SupportEntityListFrontendList;
  action: ActionType;
}) => {
  const doUpdate = useApi(FrontendSupportService.update);
  if (data.replyIsRead || data.status !== 'REPLY') {
    return null;
  }
  return (
    <Button
      onClick={async () => {
        await doUpdate({
          id: data!.id! as any,
          requestBody: {replyIsRead: true},
        });
        action.reload();
      }}
    >
      設為已讀
    </Button>
  );
};

export const BackendSupportCenter = () => {
  const getList = useApi(FrontendSupportService.findAll);
  const del = useApi(FrontendSupportService.delete);
  return (
    <CommonManager
      headerActions={[BackendSupportReport]}
      rowActions={[SetIsReadButton]}
      request={genRequest(getList)}
      params={{sortKey: 'id', sortType: 'DESC'}}
      onDelete={async row => {
        await del(row);
      }}
      columns={[
        CommonTable.Utils.Sorter({
          title: '回報時間',
          dataIndex: 'createdAt',
          valueType: 'date',
        }),
        CommonTable.Utils.Sorter({title: '回報問題', dataIndex: 'content'}),

        CommonTable.Utils.Sorter({title: '管理員回覆內容', dataIndex: 'reply'}),
        CommonTable.Utils.Sorter({
          title: '狀態',
          dataIndex: 'status',
          valueEnum: {
            OPEN: '等待回覆',
            REPLY: '已回覆',
            CLOSE: '已關閉',
          },
        }),
      ]}
    />
  );
};
